export default "./dist/stdassets/images/icons/edit-duplicate.png";